export var LadderPositionContent;
(function (LadderPositionContent) {
    LadderPositionContent["Port"] = "Port";
    LadderPositionContent["Starboard"] = "Starboard";
})(LadderPositionContent || (LadderPositionContent = {}));
//# sourceMappingURL=LadderPositionContent.js.map